import { useCallback } from 'react';
import { Tag } from 'antd';
import { PAYMENT_STATUS_COLORS, PAYMENT_STATUS_ICONS } from '../constants';

export const usePaymentStatusRender = () => {
  return useCallback((status: string) => {
    if (!status) return '-';
    
    const color = PAYMENT_STATUS_COLORS[status as keyof typeof PAYMENT_STATUS_COLORS] || 'default';
    const icon = PAYMENT_STATUS_ICONS[status as keyof typeof PAYMENT_STATUS_ICONS] || null;
    
    return (
      <Tag 
        color={color} 
        icon={icon}
        style={{ fontWeight: 500 }}
      >
        {status}
      </Tag>
    );
  }, []);
};